<template>
    <div class="modal-container has-background-sBlue">
             <div class="modal-header has-background-sBlue has-text-warning">
                 <b>Choose a plan for <img src="@/assets/img/chevronsY.png" width="18"/><span class="has-text-white">{{item.slink}}</span ></b>
             </div>
 
             <div class="modal-body">
                 <div class="has-text-centered top20">
                    <b @click="warnDisabled('m')"><input type="radio" value="monthly" :checked="period == 'Monthly'" name="period" @click="setPeriod('Monthly')" :disabled="mDisabled"/> <span class="is-size-4 has-text-white" :class="{textDisabled: mDisabled}">Monthly&nbsp;&nbsp;</span></b>
                        <span class="is-size-4 has-text-turk"><b>|</b>&nbsp;&nbsp;</span>
                       <b @click="warnDisabled('y')"> <input type="radio" value="yearly" :checked="period == 'Yearly'" name="period" @click="setPeriod('Yearly')" :disabled="yDisabled" /> <span class="is-size-4 has-text-white" :class="{textDisabled: yDisabled}">Yearly</span></b>
                       <div class="top5 has-text-danger">{{errMessage}}</div>
                 </div>
                 <div class="top30 isPoppins">
                    <div class="columns has-text-centered">
                        <div class="column planPanelChooser" @click="select('Small')">
                            <div class="planTitleHome">BASIC</div>
                            <div class="is-size-3 top20"><b>${{sp}}</b></div>
                            <button class="button is-turk top10"><b>SELECT</b></button><br>
                           
                            <div class="has-text-yell top10"><b>{{sl}} subslinks</b></div>
                            <div class="has-text-yell">-</div>
                            <div class="has-text-yell">SlinkPage & QRs</div>
                            <div class=" is-size-7 has-text-grey-light">2 million redirects/yr</div>
                        </div>
                        <div class="column planPanelChooser"  @click="select('Medium')">
                            <div  class="planTitleHome">PERSONAL</div>
                            <div class="is-size-3 top20"><b>${{mp}}</b></div>
                            <button class="button is-turk top10"><b>SELECT</b></button><br>
                           
                            <div class="has-text-yell top10"><b>{{ml}} subslinks</b></div>
                            <div class="has-text-yell">Analytics</div>
                            <div class="has-text-yell">SlinkPage & QRs</div>
                            <div class=" is-size-7 has-text-grey-light">3 million redirects/yr</div>
                        </div>
                        <div class="column planPanelChooser"  @click="select('Large')">
                            <div  class="planTitleHome">PRO</div>
                            <div class="is-size-3 top20"><b>${{pp}}</b></div>
                            <button class="button is-turk top10"><b>SELECT</b></button><br>
                           
                            <div class="has-text-yell top10"><b>{{pl}} subslinks</b></div>
                            <div class="has-text-yell">Analytics</div>
                            <div class="has-text-yell">SlinkPage & QRs</div>
                            <div class=" is-size-7 has-text-grey-light">5 million redirects/yr</div>
                        </div>
                    </div>
                 </div>
                 <div class="has-text-centered">
                    
                 </div>
                 <div class="top25">
                     
                     <div class="has-text-centered">
                       <!--  <button id="sendButt" class="button is-warning is-small top20" @click="go">SELECT</button>&nbsp;  -->
                        <button class="button top20 is-small is-warning" @click="cancel">CANCEL</button>
                     </div>
                 </div>
            </div>
 
           
          
            <br>
    </div>
 </template>
 
 <script>
 
 export default{
     props: 
        {
            item: {
                type: Object,
                default: {}
            },
            code: {
                type: String,
                default: ''
            },
            isEdit: {
                type: Boolean,
                default: false
            },
            itemId: {
                type: String,
                default: ''
            }
        },
     data: function(){
         return {
           period: 'Monthly',
           pp: 0,
           mp: 0,
           sp: 0,
           pl: 0,
           ml: 0,
           sl:0,
           mDisabled: false,
           yDisabled: false,
           errMessage: ''
         }
     },
     mounted: function(){
        console.log('called')
        this.setPeriod('Monthly')
        var self = this

        this.$root.cartContents.forEach(e => {
            if(e.code.split('Monthly').length > 1  && !self.isEdit){
                self.yDisabled = true
        
            } else if(e.code.split('Yearly').length > 1 && !self.isEdit){
                self.mDisabled = true
                self.setPeriod('Yearly')
            } 
        })
     },
     methods: {
         cancel: function(){
             this.$emit('close')
         },
         select: function(plan){    
            var temp =  plan + '' + this.period
            if(!this.isEdit)
                this.$root.planSelected('slink', this.item.slink, plan + this.period)
            else
                this.$root.planEdited('slink', this.item.slink, plan + this.period, this.itemId)
            this.$emit('close')
         },

         setPeriod: function (val){
            
            this.period = val

            this.pp = this.$root.newPlans['Large' + val].price
            this.mp = this.$root.newPlans['Medium' + val].price
            this.sp = this.$root.newPlans['Small' + val].price
            this.pl = this.$root.newPlans['Large' + val].limit
            this.ml = this.$root.newPlans['Medium' + val].limit
            this.sl = this.$root.newPlans['Small' + val].limit
         },


         warnDisabled: function(val){
            if(this.mDisabled && val=='m'){
                this.errMessage = 'Please checkout with all of your yearly plan slinks first and then create a new cart with your monthly plan ones.'
            } else if(this.yDisabled && val=='y'){
                this.errMessage = 'Please checkout with all of your monthly plan slinks first and then create a new cart with your yearly plan ones.'
            }
         }
        
     }

     
   
 }
 
 </script>
 
 <style scoped>
     .modal-container {
         max-width: 500px;
         min-height: 330px;
         border-radius: 15px;
         overflow: hidden;
         border-top: 6px solid #ffb227;
         padding: 15px
     }
     .whiteInput{
         background-color: whitesmoke !important;
         width: 150px;
     }
 </style>


// WEBPACK FOOTER //
// src/components/PlanChooser.vue